import {
  KalturaTag,
  KalturaTranslationToken,
  TagAddAction,
  TagAddActionArgs,
} from '@kaltura-ott/ott-client-types/api/types';

import { kalturaClient } from '../kaltura-clent';

export interface MetaTagAddActionArgs {
  tag: string;
  metaId: number;
}

/**
 *
 * @param tagData
 * @param language
 */
export const createMetaTag = (tagData: MetaTagAddActionArgs, language = 'eng') => {
  const client = kalturaClient();
  client.appendDefaultRequestOptions({ language: '*' });
  const data: TagAddActionArgs = {
    tag: new KalturaTag({
      type: tagData.metaId,
      multilingualTag: [
        new KalturaTranslationToken({
          language: language,
          value: tagData.tag,
        }),
      ],
    }),
  };
  const action = new TagAddAction(data);
  return client.request(action);
};
